<div
  *ngIf="show"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
>
  <div
    [class]="
      backgroundColorClass + ' rounded-lg p-8 max-w-md mx-4 shadow-xl border ' + borderColorClass
    "
    [style.background-color]="backgroundColorStyle"
  >
    <div class="flex flex-col items-center text-center">
      <mat-spinner
        [diameter]="60"
        class="mb-4"
        [color]="config.spinnerColor || 'primary'"
      ></mat-spinner>

      <h3 *ngIf="config.title" class="text-xl font-semibold mb-2" [class]="titleColorClass">
        {{ config.title }}
      </h3>

      <p *ngIf="config.subtitle" class="mb-4" [class]="subtitleColorClass">
        {{ config.subtitle }}
      </p>

      <div
        *ngIf="config.message"
        class="flex items-center text-sm mb-4"
        [class]="messageColorClass"
      >
        <mat-icon *ngIf="config.icon" class="mr-2" style="font-size: 16px">
          {{ config.icon }}
        </mat-icon>
        {{ config.message }}
      </div>

      <button
        *ngIf="config.showButton && config.buttonText"
        mat-button
        [color]="config.buttonColor || 'primary'"
        (click)="onButtonClick()"
        class="mt-4"
        [class]="buttonColorClass"
      >
        {{ config.buttonText }}
      </button>
    </div>
  </div>
</div>
